<template>
  <section class="adminSectionActivityEdit">
    <div class="adminContent">
      <h2>ActivityEdit</h2>
      <form @submit.prevent="editData" @reset.prevent="closeEdit">
        <div class="d-flex flex-row-reverse">
          <div class="p-2">
            <button type="reset" class="btn">
              <i class="material-icons">close</i>
            </button>
          </div>
          <div class="p-2">
            <button type="submit" class="btn">
              <i class="material-icons">done</i>
            </button>
          </div>
        </div>
        <div class="form-group">
          <label for="title">
            Title
            <span class="necessary">*</span>
          </label>
          <input
            class="form-control"
            type="text"
            name="title"
            v-model="configBlogData.activityTitle"
            :class="{check:necessary, invalid:!configBlogData.activityTitle}"
          />
        </div>
        <div>
          <div class="d-flex justify-content-between align-items-center">
            <div class>
              Image
              <span class="necessary">*</span>
            </div>
            <button type="button" class="btn">
              <i
                @click="addNewCol(configBlogData.activityBlogImages,null)"
                class="material-icons"
              >add</i>
            </button>
          </div>
          <div
            v-for="(image,index) in configBlogData.activityBlogImages"
            :key="index"
            class="form-group"
            id="imagegroup"
          >
            <div class="d-flex justify-content-between align-items-center">
              <label for="image">{{index+1}}</label>
            </div>
            <input
              class="form-control"
              type="text"
              name="image"
              v-model="configBlogData.activityBlogImages[index]"
              :class="{check:necessary, invalid:!configBlogData.activityBlogImages[index]}"
            />
            <!-- <img :src="configBlogData.activityBlogImages[index]" /> -->
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="date">
              Date
              <span class="necessary">*</span>
            </label>
            <select
              class="form-control"
              id="date"
              v-model="configBlogData.activityDate.date"
              :class="{check:necessary, invalid:!configBlogData.activityDate.date}"
            >
              <option>01</option>
              <option>02</option>
              <option>03</option>
              <option>04</option>
              <option>05</option>
              <option>06</option>
              <option>07</option>
              <option>08</option>
              <option>09</option>
              <option>10</option>
              <option>11</option>
              <option>12</option>
              <option>13</option>
              <option>14</option>
              <option>15</option>
              <option>16</option>
              <option>17</option>
              <option>18</option>
              <option>19</option>
              <option>20</option>
              <option>21</option>
              <option>22</option>
              <option>23</option>
              <option>24</option>
              <option>25</option>
              <option>26</option>
              <option>27</option>
              <option>28</option>
              <option>29</option>
              <option>30</option>
              <option>31</option>
              <option>32</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="month">
              Month
              <span class="necessary">*</span>
            </label>
            <select
              class="form-control"
              id="month"
              v-model="configBlogData.activityDate.month"
              :class="{check:necessary, invalid:!configBlogData.activityDate.month}"
            >
              <option>JAN</option>
              <option>FEB</option>
              <option>MAR</option>
              <option>APR</option>
              <option>MAY</option>
              <option>JUN</option>
              <option>JUL</option>
              <option>AUG</option>
              <option>SEP</option>
              <option>OCT</option>
              <option>NOV</option>
              <option>DEC</option>
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="year">
              Year
              <span class="necessary">*</span>
            </label>
            <select
              class="form-control"
              id="year"
              v-model="configBlogData.activityDate.year"
              :class="{check:necessary, invalid:!configBlogData.activityDate.year}"
            >
              <option>2019</option>
              <option>2020</option>
              <option>2021</option>
              <option>2022</option>
              <option>2023</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label for="vendorName">
            Content
            <span class="necessary">*</span>
          </label>
          <div :class="{check:necessary, invalid:!content}">
            <quill-editor
              v-model="content"
              ref="myQuillEditor"
              :options="editorOption"
              @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)"
            ></quill-editor>
          </div>
        </div>
        <div class="form-group">
          <label for="vendorName">
            vendorName
            <span class="necessary">*</span>
          </label>
          <input
            class="form-control"
            type="text"
            name="vendorName"
            v-model="configBlogData.vendorName"
            :class="{check:necessary, invalid:!configBlogData.vendorName}"
          />
        </div>
        <div class="form-group">
          <label for="vendorNumber">
            vendorNumber
            <span class="necessary">*</span>
          </label>
          <input
            class="form-control"
            type="text"
            name="vendorNumber"
            v-model="configBlogData.vendorNumber"
            :class="{check:necessary, invalid:!configBlogData.vendorNumber}"
          />
        </div>
        <div class="form-group">
          <label for="vendorPhone">
            vendorPhone
            <span class="necessary">*</span>
          </label>
          <input
            class="form-control"
            type="text"
            name="vendorPhone"
            v-model="configBlogData.vendorPhone"
            :class="{check:necessary, invalid:!configBlogData.vendorPhone}"
          />
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            name="activityIsOpen"
            v-model="configBlogData.activityIsOpen"
          />
          <label class="form-check-label" for="activityIsOpen">activityIsOpen</label>
        </div>
        <div class="form-group">
          <label for="activityAddress">activityAddress</label>
          <input
            class="form-control"
            type="text"
            name="activityAddress"
            v-model="configBlogData.activityAddress"
          />
        </div>
        <div class="form-group">
          <label for="activityDuringTIme">activityDuringTIme</label>
          <input
            class="form-control"
            type="text"
            name="activityDuringTIme"
            v-model="configBlogData.activityDuringTIme"
          />
        </div>
        <div class="form-group">
          <label for="activityPrice">activityPrice</label>
          <input
            class="form-control"
            type="text"
            name="activityPrice"
            v-model="configBlogData.activityPrice"
          />
        </div>
        <div class="form-group">
          <label for="address">address</label>
          <input class="form-control" type="text" name="address" v-model="configBlogData.address" />
        </div>
        <div>
          <div class="d-flex justify-content-between align-items-center">
            <label>Info</label>
            <button type="button" class="btn">
              <i @click="addNewCol(configBlogData.activityInfo,null)" class="material-icons">add</i>
            </button>
          </div>
          <div v-for="(info,index) in configBlogData.activityInfo" :key="index" class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label for="info">{{index+1}}</label>
              <button type="button" class="btn">
                <i
                  @click="removeCol(configBlogData.activityInfo,index)"
                  class="small material-icons"
                >clear</i>
              </button>
            </div>
            <input
              class="form-control"
              type="text"
              name="info"
              v-model="configBlogData.activityInfo[index]"
            />
          </div>
        </div>
        <div>
          <div class="d-flex justify-content-between align-items-center">
            <label>Ship</label>
            <button type="button" class="btn">
              <i
                @click="addNewCol(configBlogData.ship,{shipImage:null,shipName:null})"
                class="material-icons"
              >add</i>
            </button>
          </div>
          <div v-for="(ship,index) in configBlogData.ship" :key="index" class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label for="ship">{{index+1}}</label>
              <button type="button" class="btn">
                <i @click="removeCol(configBlogData.ship,index)" class="small material-icons">clear</i>
              </button>
            </div>
            <input
              class="form-control"
              type="text"
              name="ship"
              v-model="configBlogData.ship[index].shipImage"
            />
            <input
              class="form-control"
              type="text"
              name="ship"
              v-model="configBlogData.ship[index].shipName"
            />
          </div>
        </div>
      </form>
      <div class="overlay-sidebar trans-0-4"></div>
      <div class="sidebar trans-0-4">
        <div class="pt-3 pb-4 d-flex justify-content-between">
          <button type="button" class="btn contentCenter" @click="changeFolder(previousStorage)">
            <i class="largeSize material-icons pr-2">subdirectory_arrow_left</i>
            <span>{{previousStorage.name}}</span>
          </button>
          <button type="button" class="btn contentCenter btn-hide-sidebar">
            <i class="largeSize material-icons pr-2">close</i>
          </button>
        </div>
        <div class="pb-2" v-for="(sg,index) in currentStorage" :key="index">
          <div class="contentCenter" v-if="sg.url">
            <button type="button" class="btn btn-hide-sidebar" @click="insertImage(sg)">
              <div class="imagebox">
                <div class="inner">
                  <div class="image" :style="{'background-image':'url('+sg.url+')'}"></div>
                </div>
              </div>
              {{sg.name}}
            </button>
          </div>
          <div v-if="!sg.url">
            <button type="button" class="btn contentCenter" @click="changeFolder(sg)">
              <i class="largeSize material-icons pr-2">folder_open</i>
              <span>{{sg.name}}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
//Import Quill Editer
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

//Quill Editor Setting
//Quill Editor Tool Redefine
const handlers = {
  image: function() {
    $(".adminContent .sidebar").addClass("show-sidebar");
    $(".adminContent .overlay-sidebar").addClass("show-overlay-sidebar");
  }
};
//Quill Editor Total Settig
const quillEditorSetting = {
  modules: {
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike"], //加粗，斜體，下劃線，刪除線
        ["blockquote", "code-block"], //引用，程式碼塊

        [{ header: 1 }, { header: 2 }], // 標題，鍵值對的形式；1、2表示字型大小
        [{ list: "ordered" }, { list: "bullet" }], //列表
        [{ script: "sub" }, { script: "super" }], // 上下標
        [{ indent: "-1" }, { indent: "+1" }], // 縮排
        [{ direction: "rtl" }], // 文字方向

        [{ size: ["small", false, "large", "huge"] }], // 字型大小
        [{ header: [1, 2, 3, false] }], //幾級標題

        [{ color: [] }, { background: [] }], // 字型顏色，字型背景顏色
        [{ font: [] }], //字型
        [{ align: [] }], //對齊方式

        ["clean"], //清除字型樣式
        ["link", "video"], //上傳連結、上傳視訊

        ["image"] //Redefine: upload picture from firebase
      ],
      handlers: handlers
    }
  },
  theme: "snow"
};

export default {
  name: "activityEdit",
  components: {
    quillEditor
  },
  data() {
    return {
      configBlogData: {
        //necessary
        activityContent: [""],
        activityBlogImages: [""],
        activityTitle: "",
        activityDate: {
          date: "",
          month: "",
          year: ""
        },
        vendorName: "",
        vendorNumber: "",
        vendorPhone: "",
        //unnecessary
        activityIsOpen: false,
        activityAddress: null,
        activityDuringTIme: null,
        activityPrice: null,
        address: null,
        activityInfo: [""],
        ship: [{ shipImage: "", shipName: "" }]
      },
      content: "",
      storage: [{ router: "", url: "", name: "main" }],
      currentStorage: [],
      previousStorage: { router: "", url: "", name: "main" },
      necessary: false,
      editorOption: quillEditorSetting
    };
  },
  created() {
    if (this.$route.params.index != "addData") {
      let self = this;
      const p = new Promise((resolve, reject) => {
        const readVendorInfo = firebaseDB.ref("activities");
        readVendorInfo
          .orderByKey()
          .equalTo(this.$route.params.index)
          .on("value", function(snapshot) {
            snapshot.forEach(function(childSnapshot) {
              self.configBlogData = childSnapshot.val();
            });
            resolve();
          });
      })
        .then(() => {
          self.content = self.configBlogData.activityContent.join("");
          let image;
          for (
            let i = 0;
            i < self.configBlogData.activityBlogImages.length;
            i++
          ) {
            image =
              '<img src="' + self.configBlogData.activityBlogImages[i] + '">';
            self.content = self.content.replace("{{picture}}", image);
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
    this.storageSearch(this.previousStorage);
    // const q = new Promise((resolve, reject) => {
    //   firebaseSG
    //     .ref("vendorActivities/vendor01/activity01/1.jpg")
    //     .getDownloadURL()
    //     .then(url => {
    //       console.log(url);
    //     });
    // });
  },
  methods: {
    editData() {
      if (this.checkNecessary()) {
        this.handleData();
        let key = null;
        if (this.$route.params.index != "addData") {
          key = firebaseDB
            .ref("activities/" + this.$route.params.index)
            .update(this.configBlogData);
        } else {
          key = firebaseDB
            .ref("activities")
            .child(this.configBlogData.vendorActivityNum)
            .update(this.configBlogData);
        }
        key.then(() => {
          this.$router.push({ name: "activity" });
        });
      }
    },
    closeEdit() {
      let res = confirm("資料尚未保存確定要離開?");
      if (res == true) {
        this.$router.push({ name: "activity" });
      }
    },
    addNewCol(data, type) {
      data.push(type);
    },
    removeCol(data, index) {
      data.splice(index, 1);
    },
    handleData() {
      if (this.$route.params.index == "addData") {
        const dateTime = Date.now();
        const timestamp = Math.floor(dateTime / 1000);
        this.configBlogData.vendorActivityNum = "activity-" + timestamp;
      }
      this.configBlogData.routeName =
        "/blog/" +
        this.configBlogData.vendorNumber +
        "/" +
        this.configBlogData.vendorActivityNum;
      let finalImage = this.content.match(/<img src=".*?">/g);
      for (let i = 0; i < finalImage.length; i++) {
        finalImage[i] = finalImage[i].replace(/<img src="|">/g, "");
      }
      this.configBlogData.activityBlogImages = finalImage;
      let finalContent = this.content.replace(
        /<img src=".*?">/g,
        "{{picture}}"
      );
      this.configBlogData.activityContent = [];
      this.configBlogData.activityContent[0] = finalContent;
    },
    checkNecessary() {
      let check = true;
      this.necessary = true;
      if (this.configBlogData.activityTitle == "") {
        check = false;
      }
      if (this.configBlogData.vendorName == "") {
        check = false;
      }
      if (this.configBlogData.vendorNumber == "") {
        check = false;
      }
      if (this.configBlogData.vendorPhone == "") {
        check = false;
      }
      if (this.configBlogData.activityDate.date == "") {
        check = false;
      }
      if (this.configBlogData.activityDate.month == "") {
        check = false;
      }
      if (this.configBlogData.activityDate.year == "") {
        check = false;
      }
      if (this.configBlogData.activityBlogImages[0] == "") {
        check = false;
      }
      if (this.content == "") {
        check = false;
      }
      return check;
    },
    //Firebase Storage Methods
    changeFolder(sg) {
      let tem = sg.router.split("/");
      if (sg.url == null) {
        this.storageSearch(sg);
      } else if (sg.url == "") {
        this.currentStorage = [];
        this.storage.forEach(el => {
          let elRouter = el.router.split("/");
          if (tem.length + 1 == elRouter.length) {
            if (el.router.includes(sg.router)) {
              this.currentStorage.push(el);
            }
          }
        });
      }
      tem.pop();
      let router = tem.join("/");
      this.storage.forEach(el => {
        if (el.router == router) {
          this.previousStorage = el;
        }
      });
    },
    insertImage(sg) {
      let quillRef = this.$refs.myQuillEditor.quill;
      let index = quillRef.getSelection().index;
      quillRef.insertEmbed(index, "image", sg.url);
      $(".sidebar").removeClass("show-sidebar");
      $(".overlay-sidebar").removeClass("show-overlay-sidebar");
    },
    storageSearch(sg) {
      for (let i = 0; i < this.storage.length; i++) {
        if (this.storage[i].router == sg.router) {
          this.storage[i].url = "";
          break;
        }
      }
      this.currentStorage = [];
      let storagePromise = new Promise((storageResolve, storageReject) => {
        firebaseSG
          .ref(sg.router)
          .list()
          .then(ref => {
            ref.prefixes.forEach(folderRef => {
              let newRouter = sg.router + "/" + folderRef.name;
              let url = null;
              this.storage.push({
                router: newRouter,
                url: url,
                name: folderRef.name
              });
              this.currentStorage.push({
                router: newRouter,
                url: url,
                name: folderRef.name
              });
            });
            ref.items.forEach(itemRef => {
              let newRouter = sg.router + "/" + itemRef.name;
              itemRef.getDownloadURL().then(url => {
                this.storage.push({
                  router: newRouter,
                  url: url,
                  name: itemRef.name
                });
                this.currentStorage.push({
                  router: newRouter,
                  url: url,
                  name: itemRef.name
                });
              });
            });
            storageResolve();
          });
      })
        .then()
        .catch(err => {
          console.log(err);
        });
    },
    //editor function
    onEditorReady(editor) {
      // 準備編輯器
    },
    onEditorBlur() {}, // 失去焦點事件
    onEditorFocus() {}, // 獲得焦點事件
    onEditorChange() {} // 內容改變事件
  }
};
</script>

<style scoped>
/* ---------------------------------------------------
        adminContent STYLE
----------------------------------------------------- */

.adminContent {
  width: calc(100% - 250px);
  min-height: calc(100% - 70px);
  transition: all 0.3s;
  position: relative;
  top: 70px;
  right: 0;
  padding: 30px 25px;
  margin-left: 250px;
  background-color: #ebebeb;
}

.adminContent.active {
  width: 100%;
  margin-left: 0;
}

.adminContent td {
  vertical-align: middle;
}

.adminContent select {
  height: 30px !important;
}

.adminContent button:focus {
  box-shadow: 0 0 0 !important;
}

.adminContent button:active {
  box-shadow: 0 0 0 !important;
}

.adminContent .material-icons {
  line-height: unset;
}

.adminContent form .check.invalid {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(245, 41, 41, 0.6) !important;
}

.adminContent .necessary {
  color: red;
}

.adminContent i.largeSize {
  font-size: 40px;
}

.adminContent .btn span {
  font-size: 20px;
}

.adminContent .contentCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

.adminContent .imagebox {
  width: 320px;
  overflow: hidden;
  z-index: 1500;
}

.adminContent .imagebox .inner {
  width: 100%;
  padding-top: 75%;
  height: 0;
  position: relative;
}

.adminContent .imagebox .inner .image {
  border-radius: 10px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.adminContent #imagegroup > .image.selected {
}
/* ---------------------------------------------------
        MEDIAQUERIES
    ----------------------------------------------------- */

@media (max-width: 768px) {
  .adminContent {
    width: 100%;
  }
  .adminContent.active {
    width: calc(100% - 250px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin-manage/ActivityEdit.vue